import type { StoragePlace } from "@larder/shared";
import { useEffect, useState } from "react";
import { watchStorages } from "./storages";

/** The household's storage places, live. */
export function useStorages(locationId: string | null): {
  places: StoragePlace[];
  error: string | null;
} {
  const [places, setPlaces] = useState<StoragePlace[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!locationId) {
      setPlaces([]);
      return;
    }
    setError(null);
    return watchStorages(locationId, setPlaces, (e) => setError(e.message));
  }, [locationId]);

  return { places, error };
}
